<div class="mensajes-wrapper" style="padding: 20px; max-width: 1200px; margin: 0 auto;">
    <div class="header-section" style="margin-bottom: 25px; display: flex; justify-content: space-between; align-items: center;">
        <div>
            <h1 style="margin: 0; font-size: 1.8rem; font-weight: bold; color: #124e91; display: flex; align-items: center; gap: 8px;">
                <mat-icon style="font-size: 1.8rem; width: auto; height: auto;">mail</mat-icon> Mis Mensajes
            </h1>
            <p style="margin: 5px 0 0 0; color: #666; font-size: 0.95rem;">Consultá tus notificaciones y avisos importantes.</p>
        </div>
        <div *ngIf="unreadCount > 0" style="background-color: #ff3b30; color: white; padding: 5px 12px; border-radius: 20px; font-weight: bold; font-size: 0.85rem; display: flex; align-items: center; gap: 6px;">
            <mat-icon style="font-size: 1.1rem; width: auto; height: auto;">mark_email_unread</mat-icon>
            {{ unreadCount }} no {{ unreadCount === 1 ? 'leído' : 'leídos' }}
        </div>
    </div>

    <div *ngIf="loading && mensajes.length === 0" style="display: flex; flex-direction: column; align-items: center; padding: 40px;">
        <mat-spinner diameter="40" style="margin-bottom: 10px;"></mat-spinner>
        <span style="color: #666;">Cargando tus mensajes...</span>
    </div>

    <div *ngIf="!loading && mensajes.length === 0" style="background: white; border: 1px dashed #ccc; border-radius: 8px; padding: 40px; text-align: center; color: #777;">
        <mat-icon style="font-size: 3rem; width: auto; height: auto; color: #aaa; margin-bottom: 10px;">mail_outline</mat-icon>
        <p style="margin: 0; font-size: 1.1rem; font-weight: 500;">No tenés mensajes en tu bandeja de entrada.</p>
    </div>

    <div class="grid-layout" *ngIf="mensajes.length > 0" style="display: grid; grid-template-columns: 2.2fr 2.8fr; gap: 20px; min-height: 500px;">
        <!-- Listado de Mensajes -->
        <mat-card style="padding: 0; overflow: hidden; display: flex; flex-direction: column;">
            <div style="background-color: #124e91; color: white; padding: 12px 15px; font-weight: bold; display: flex; align-items: center; gap: 8px;">
                <mat-icon>inbox</mat-icon> Bandeja de Entrada
            </div>
            <div class="list-container" style="overflow-y: auto; max-height: 600px; flex-grow: 1;">
                <div *ngFor="let m of mensajes" 
                     (click)="seleccionarMensaje(m)"
                     [style.borderLeftColor]="m.leido ? 'transparent' : '#124e91'"
                     [style.backgroundColor]="selectedMensaje?._id === m._id ? '#e8f0fe' : 'transparent'"
                     style="padding: 15px; border-bottom: 1px solid #eee; cursor: pointer; transition: all 0.2s; border-left: 4px solid transparent; display: flex; align-items: flex-start; gap: 12px;"
                     onmouseover="this.style.backgroundColor=this.style.backgroundColor==='#e8f0fe'?'#e8f0fe':'#f0f4fb'"
                     onmouseout="this.style.backgroundColor=this.style.backgroundColor==='#e8f0fe'?'#e8f0fe':'transparent'">
                    <div style="color: #124e91; margin-top: 2px;">
                        <mat-icon>{{ m.leido ? 'drafts' : 'mail' }}</mat-icon>
                    </div>
                    <div style="flex-grow: 1;">
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px;">
                            <span style="font-size: 0.75rem; color: #888;">{{ m.fechaEnvio || m.createdAt | date: "dd/MM/yyyy HH:mm" }}</span>
                            <span *ngIf="!m.leido" style="background-color: #124e91; color: white; font-size: 0.65rem; padding: 2px 6px; border-radius: 4px; font-weight: bold; text-transform: uppercase;">Nuevo</span>
                        </div>
                        <h4 [style.fontWeight]="m.leido ? 'normal' : 'bold'" style="margin: 0 0 4px 0; font-size: 0.95rem; color: #333;">{{ m.asunto }}</h4>
                        <p style="margin: 0; font-size: 0.85rem; color: #666; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; line-height: 1.3;">
                            {{ m.cuerpo }}
                        </p>
                    </div>
                </div>
            </div>
        </mat-card>

        <!-- Detalle del Mensaje -->
        <div>
            <mat-card *ngIf="selectedMensaje" style="padding: 20px; min-height: 400px; display: flex; flex-direction: column; background-color: #fff; position: relative;">
                <div style="border-bottom: 1px solid #eee; padding-bottom: 15px; margin-bottom: 20px;">
                    <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                        <h2 style="margin: 0; font-size: 1.3rem; color: #124e91; font-weight: bold;">{{ selectedMensaje.asunto }}</h2>
                    </div>
                    <div style="font-size: 0.8rem; color: #777; margin-top: 5px; display: flex; align-items: center; gap: 4px;">
                        <mat-icon style="font-size: 1rem; width: auto; height: auto;">schedule</mat-icon>
                        Recibido el {{ selectedMensaje.fechaEnvio || selectedMensaje.createdAt | date: "dd/MM/yyyy HH:mm" }}
                    </div>
                </div>
                <div style="flex-grow: 1; font-size: 0.95rem; color: #333; line-height: 1.6; white-space: pre-wrap; word-break: break-word;">
                    {{ selectedMensaje.cuerpo }}
                </div>
            </mat-card>

            <div *ngIf="!selectedMensaje" style="border: 2px dashed #ddd; border-radius: 8px; height: 100%; min-height: 400px; display: flex; align-items: center; justify-content: center; color: #888; padding: 20px; text-align: center; background-color: #fafafa;">
                <div>
                    <mat-icon style="font-size: 3rem; width: auto; height: auto; color: #ccc; margin-bottom: 10px;">arrow_back</mat-icon>
                    <p style="margin: 0; font-size: 1rem;">Seleccioná un mensaje del listado para leer su contenido completo.</p>
                </div>
            </div>
        </div>
    </div>
</div>
